import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import servicosSolicitacao from "../../servicos/servicos-solicitacao";
import { Form } from "semantic-ui-react";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { ToastContainer, toast } from 'react-toastify';
import AuthContext from "../../servicos/autorizacao/AuthContex";
import { useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";
import Delete from "../../img/svgs/Delete";
import Cancel from "../../img/svgs/Cancel";
import Salvar from "../../img/svgs/Salvar";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import ShareIcon from '@mui/icons-material/Share';
import ExcelJS from 'exceljs';
import moment from "moment";

const ListTodasSolicitacoes = () => {
  const { user } = useContext(AuthContext);
  const autorizado = user.role === 'root' || user.role === 'admin';

  const [solicitacoes, setSolicitacoes] = useState([]);
  const [editado, setEditado] = useState(false)
  const [deletado, setDeletado] = useState(false)
  const [show, setShow] = useState(false);
  const containerRef = useRef(null);
  const [solicitacao, setSolicitacao] = useState();
  const [showExcluir, setShowExcluir] = useState(false);
  const [idExcluir, setIdExcluir] = useState();
  const [listaFiltrada, setListaFiltrada] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleClose = () => setShow(false);

  useEffect(() => {
    function getDados() {
      servicosSolicitacao.listarTodasSolicitacoes()
        .then(response => {
          if (response.status === 200) {
            setSolicitacoes(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [deletado, editado, listaFiltrada]);

  const cancelarSolicitacao = () => {
    setEditado(false);
    const data = {
      "status": "cancelado"
    }

    servicosSolicitacao.cancelarSolicitacao(solicitacao.id_solicitacao, data).then(response => {
      if (response.status === 200) {
        setEditado(true);
        toast.success("Solicitação cancelada com sucesso!", {
          theme: "colored",
        });
      } else {
        toast.error('Não foi possível cancelar a solicitação!')
      }
    })
    handleClose()
  }

  const deletarSolicitacao = () => {
    setDeletado(false)
    servicosSolicitacao.deletar(idExcluir).then(response => {
      if (response.status === 200) {
        setDeletado(true);
        toast.success("Solicitação deletada com sucesso!", {
          theme: "colored",
        });
      }
    }).catch(error => {
      console.log(error);
      toast.error("Não foi possível deletar a atribuição!", {
        theme: "colored"
      });
    })
    setShowExcluir(false);

  }


  const handleShow = (solicitacao) => {
    setIdExcluir(solicitacao.id_solicitacao);
    setSolicitacao(solicitacao);
    setShow(true);
  }


  const handleCloseExcluir = () => {
    setShowExcluir(false);
  }


  const handleShowExcluir = (id) => {
    setShowExcluir(true);
    setIdExcluir(id);
  }

  const handlePesquisa = (e) => {
    const pesquisa = e.target.value;
    let listaAtualizada = [];
    if (pesquisa !== "") {
      listaAtualizada = solicitacoes.filter((item) => {
        return String(item.Colaborador[0].nome).toLowerCase().indexOf(pesquisa.toLowerCase()) !== -1;
      })
      setListaFiltrada(listaAtualizada);
    } else {
      setListaFiltrada(solicitacoes);
    }

  }

  const ModalExcluir = () => {
    return <>
      <div >
        <Modal className="modal-confirmacao" show={showExcluir} onHide={handleCloseExcluir}>
          <Modal.Body className="">
            <span>Você deseja realmente deletar a solicitação?</span> <br />
          </Modal.Body>
          <Modal.Footer >
            <button type="button" className="btn-icones rounded p-1" onClick={deletarSolicitacao}><Salvar /> Deletar</button>
            <button type="button" className="btn-icones rounded p-1" onClick={handleCloseExcluir}><Cancel /> Voltar</button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  }
  const ModalEditar = () => {
    return <>

      <Modal className="" show={show} onHide={handleClose}>
        {/* <Modal.Header closeButton>
            <Modal.Title>Edição Colaboradores</Modal.Title>
          </Modal.Header> */}
        <Modal.Body className="modal-edicao" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>

                  Você deseja realmente cancelar essa solicitação?
                  <br></br>
                  {solicitacao?.Produto[0].nome && <span>Produto: <strong>{solicitacao?.Produto[0].nome}</strong></span>}
                  <br></br>
                  O colaborador receberá de volta M$: <strong>{solicitacao?.Produto[0].milhas}</strong>

                  <div className="text-center mt-4">
                    <button onClick={cancelarSolicitacao} className="btn-icones p-1 rounded w-25 me-3" >
                      <Salvar /> Salvar
                    </button>
                    <button className="btn-icones p-1 rounded w-25" onClick={handleClose}>
                      <Cancel /> Voltar
                    </button>
                  </div>

                </div>

              </div>


            </Form>
          </div>

        </Modal.Body>

      </Modal>


    </>
  }

  const columnsSolicitacoes = [
    { field: "id_solicitacao", headerName: "ID", width: 90 },
    {
      field: "Colaborador[0].nome",
      headerName: "Nome",
      width: 200,
      editable: false,
      valueGetter: (params) => {
        return params.row.Colaborador[0].nome
      }
    },
    {
      field: "produto",
      headerName: "Produto",
      width: 100,
      editable: false,
      valueGetter: (params) => {
        return params.row.Produto[0].nome
      }
    },
    {
      field: "milhas_solicitacao",
      headerName: "Milhas",
      width: 100,
      editable: false,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      editable: false,
    },
    {
      field: "data_solicitacao",
      headerName: "Data Solicitação",
      width: 150,
      editable: false,
      valueGetter: (params) => {
        let aux = String(params.value).split("-");
        let ano = aux[0];
        let mes = aux[1];
        let dia = aux[2];
        let dataFormatada = `${dia}-${mes}-${ano}`;
        return dataFormatada;
      }
    },
    {
      field: "data_entrega",
      headerName: "Data Entrega",
      width: 150,
      editable: false,
      valueGetter: (params) => {
        if (params.value !== null) {

          let aux = String(params.value).split("-");
          let ano = aux[0];
          let mes = aux[1];
          let dia = aux[2];
          let dataFormatada = `${dia}-${mes}-${ano}`;
          return dataFormatada;
        } else {
          return 'Produto não entregue'
        }
      }
    },

    {
      field: "delete",
      headerName: "Excluir",
      sortable: false,
      width: 80,
      align: "center",
      renderCell: (params) => {
        if (autorizado) {
          return <button className="btn-icones rounded p-1 border-0" onClick={() => handleShowExcluir(params.row.id_solicitacao)} ><Delete /></button>;
        } else {
          return <button className="btn-icones rounded p-1 border-0" disabled ><Delete /></button>;
        }
      }
    },
    {
      field: "cancelar",
      headerName: "Cancelar",
      align: "center",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        if (params.row.status === 'pendente') {
          return <button className="border-0 rounded btn-icones p-1" disabled onClick={() => handleShow(params.row)} ><Cancel /></button>;
        } else {
          return <button className="border-0 rounded btn-icones p-1 " disabled ><Cancel /></button>;
        }
      }
    }

  ];

  const onRowsSelectionHandler = (ids) => {
    const selectedRowsData = ids.map((item) => solicitacoes.find((row) => row.id_solicitacao === item.id_solicitacao));
    setSelectedRows(selectedRowsData);
  };

  const actions = [
    { icon: <ShareIcon />, name: 'Exportar Excel' },
  ];

  const handleActionClick = (actionName) => {
    switch (actionName) {
      case 'Exportar Excel':
        handleExportToExcel();
        break;
      default:
        break;
    }
  };

  const formatData = ({ data }) => {
    const dataf = moment(data);
    return dataf.format('DD/MM/YYYY')
  }

  const handleExportToExcel = () => {
    const selectedRowsIds = selectedRows.map((rowIndex) => rowIndex.id_solicitacao);
    const selectedSolicitacoes = solicitacoes.filter((solicitacao) => selectedRowsIds.includes(solicitacao.id_solicitacao));

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Solicitações');

    columnsSolicitacoes.forEach((column, index) => {
      if (column.field !== 'delete' && column.field !== 'cancelar') {
        worksheet.getColumn(index + 1).header = column.headerName;
        worksheet.getColumn(index + 1).key = column.field;
        worksheet.getColumn(index + 1).width = 10;
      }

    });

    selectedSolicitacoes.forEach((solicitacao) => {
      const rowData = {};
      columnsSolicitacoes.forEach((column) => {
        if (column.field === 'id_solicitacao') {
          rowData[column.field] = solicitacao.id_solicitacao;
        } else if (column.field === 'Colaborador[0].nome') {
          rowData[column.field] = solicitacao.Colaborador[0].nome
        } else if (column.field === 'status') {
          rowData[column.field] = solicitacao.status
        } else if (column.field === 'produto') {
          rowData[column.field] = solicitacao.Produto[0].nome
        } else if (column.field === 'Produto[0].milhas') {
          rowData[column.field] = solicitacao.milhas_solicitacao
        } else if (column.field === 'data_solicitacao') {
          rowData[column.field] = formatData(solicitacao.data_solicitacao)
        } else if (column.field === 'data_entrega') {
          rowData[column.field] = solicitacao.data_entrega ? formatData(solicitacao.data_entrega) : "Produto não entregue"
        }
      });
      worksheet.addRow(rowData);
    });

    const saveOptions = {
      filename: 'solicitacoes_internas.xlsx',
      useStyles: true,
      useSharedStrings: true
    };

    workbook.xlsx.writeBuffer().then((buffer) => {
      const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.download = saveOptions.filename;
      link.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
    });
  };

  const SpeedDialShared = () => {
    return (
      <Box sx={{ height: 100, transform: 'translateZ(0px)', flexGrow: 1 }}>
        <SpeedDial
          ariaLabel="SpeedDial"
          sx={{ position: 'absolute', bottom: 38, right: 16, }}
          icon={<SpeedDialIcon />}
          FabProps={{
            sx: {
              bgcolor: '#753BBD',
              '&:hover': {
                bgcolor: '#753BBD',
              }
            }
          }}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={() => handleActionClick(action.name)}
            />
          ))}
        </SpeedDial>
      </Box>
    )
  }

  return (
    <>
      <NavMenu />
      <ModalExcluir />
      <ToastContainer />
      <div className="d-flex container">
        <div className="w-25">
          <MenuLateral />
        </div>
        <div className="w-75 tabelas-gerenciais">
          <ModalEditar />
          <Box sx={{ height: 650, width: 950, marginTop: 1 }}>
            <div className="d-flex justify-content-start align-items-center mb-2">

              <div>
                <input
                  className="p-1 border-1 rounded-5"
                  type="text"
                  id="pesquisa"
                  placeholder=" Pesquise pelo nome"
                  onChange={handlePesquisa}
                />
              </div>
              <div className="ms-2">
                <h3 className="text-start subtitulo" style={{ fontSize: 20 }}>Lista de Solicitações</h3>
              </div>
            </div>

            <DataGrid
              localeText={localizedTextsMap}
              rows={listaFiltrada.length > 0 ? listaFiltrada : solicitacoes}
              columns={columnsSolicitacoes}
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              getRowId={(row) => row.id_solicitacao}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
              }
              checkboxSelection
              onSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRowData = solicitacoes.filter((row) =>
                  selectedIDs.has(row.id_solicitacao)
                )
                onRowsSelectionHandler(selectedRowData);
              }}
            />

            <Box mt={5}>
              <SpeedDialShared />
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
};

export default ListTodasSolicitacoes;